import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
console.log(
  "%c⛔⚠️ ESPERE ⚠️😱",
  `color:red;
   font-size:35px; 
   font-family:'roboto';  
   padding: 40px 45px;    
   `
);

console.log(
  `%cEste é um recurso de navegador voltado para desenvolvedores. Se alguém disse para você copiar e colar algo aqui para ativar um recurso do Arcos Dorados App ou "invadir" a conta de outra pessoa, isso é uma fraude e você dará a ele acesso à sua conta.`,
  `font-size:18px; 
   font-family:'roboto';
   `
);
reportWebVitals();
